module.exports = __webpack_public_path__ + "images/feature/20150603_04-44423385958638ad60f6513f7e516d44.png";